import React from 'react';
const comparisonRows = [{
  situation: 'Tus clases',
  without: 'Improvisás qué enseñar cada vez que llegás al dojo',
  with: 'Plan técnico de 48 semanas listo para ejecutar'
}, {
  situation: 'Tus alumnos',
  without: 'Se van sin avisarte y no sabés por qué',
  with: 'Sistema de retención que frena la deserción'
}, {
  situation: 'Tus ingresos',
  without: 'Cuotas que no cierran a fin de mes',
  with: 'Suscripciones digitales que generan ingreso pasivo'
}, {
  situation: 'Tu tiempo',
  without: 'Trabajás 6 días y el número no refleja ese esfuerzo',
  with: 'El dojo funciona aunque vos no estés presente'
}, {
  situation: 'Tu alcance',
  without: 'Solo podés llegar a los alumnos de tu barrio',
  with: 'Alumnos online de todo el país pagando cada mes'
}, {
  situation: 'Tu marketing',
  without: 'Sin sistema, sin alumnos nuevos, sin crecimiento',
  with: 'Captación orgánica constante sin gastar en publicidad'
}, {
  situation: 'Tu escalabilidad',
  without: 'Más alumnos = más horas = más agotamiento',
  with: 'Más alumnos online sin sumar una sola hora de trabajo'
}, {
  situation: 'Tu futuro',
  without: 'Un dojo que depende únicamente de tu presencia física',
  with: 'Un sistema que genera valor incluso cuando dormís'
}];
const blocks = [{
  emoji: '🎥',
  title: 'Bloque 1 — Sistema de Grabación Profesional',
  desc: 'Cómo grabar clases de calidad profesional con tu celular. Setup, iluminación, audio y edición en menos de 20 minutos por video.',
  span: false
}, {
  emoji: '🏗️',
  title: 'Bloque 2 — Arquitectura de la Academia Digital',
  desc: 'Cómo estructurar tus módulos, definir tu propuesta de valor única y diseñar el contenido antes de grabar un solo video.',
  span: false
}, {
  emoji: '💳',
  title: 'Bloque 3 — Plataforma y Cobros en Argentina',
  desc: 'Configuración completa de Hotmart en español, cobros en pesos argentinos y entrega automática del acceso al alumno.',
  span: false
}, {
  emoji: '🚀',
  title: 'Bloque 4 — Plan de Lanzamiento de 21 Días',
  desc: 'El sistema exacto para conseguir los primeros 20 alumnos online sin gastar en publicidad paga. Scripts y posts incluidos.',
  span: false
}, {
  emoji: '📦',
  title: 'Recursos incluidos:',
  desc: 'Guía de Producción · Mapa de Módulos · Configuración Hotmart · Plan de Lanzamiento 21 Días · Scripts de Venta · Sistema de Afiliados · Dashboard de Métricas · Protocolo de Retención Online',
  span: true
}];
export function ProBusiness() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(15, 5, 5)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-211">
      <div className="mx-auto max-w-4xl" data-id="element-212">
        {/* TÍTULO */}
        <div className="mb-8 text-center" data-id="element-213">
          <h2 className="font-black text-white m-0 mb-3 text-[26px]" data-id="element-214">
            🏆 ¿QUÉ AGREGA LA{' '}
            <span className="text-red-500" data-id="element-215">ACADEMIA ONLINE™</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-base text-gray-400 m-0" data-id="element-216">
            El sistema completo para digitalizar tu dojo, vender tus clases a
            todo el país y generar ingreso pasivo real desde el primer mes.
          </p>
        </div>

        {/* HINT MOBILE */}
        <p className="text-xs text-gray-600 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-217">
          <span data-id="element-218">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* TABLA COMPARATIVA */}
        <div className="mb-10 overflow-x-auto bg-gray-900 border border-red-900 rounded-xl shadow-sm touch-pan-x" style={{
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-219">
          <div className="min-w-[600px]" data-id="element-220">
            {/* HEADER */}
            <div className="grid grid-cols-3" style={{
            backgroundColor: 'rgb(20, 5, 5)'
          }} data-id="element-221">
              <div className="p-3 text-sm font-bold text-gray-300" data-id="element-222">
                Situación
              </div>
              <div className="p-3 text-center text-sm font-bold text-gray-500 border-l border-red-900" data-id="element-223">
                Sin Academia Online™
              </div>
              <div className="p-3 text-center text-sm font-bold text-red-500 border-l border-red-900" data-id="element-224">
                Con Academia Online™
              </div>
            </div>

            {/* FILAS */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-800' : ''}`} data-id="element-225">
                <div className="p-3 text-xs sm:text-sm text-gray-300 font-medium" data-id="element-226">
                  {row.situation}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-500 border-l border-gray-800 bg-gray-900/50" data-id="element-227">
                  ✗ {row.without}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-200 border-l border-gray-800 bg-red-950/30" data-id="element-228">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* BLOQUES */}
        <h3 className="text-xl font-black text-center text-white m-0 mb-6" data-id="element-229">
          ✅ ACADEMIA ONLINE™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-230">
          {blocks.map(block => <div key={block.title} className={`bg-gray-900 border border-red-900 rounded-lg p-4 shadow-sm ${block.span ? 'md:col-span-2' : ''}`} data-id="element-231">
              <h4 className="text-base font-bold text-red-500 m-0 mb-1" data-id="element-232">
                {block.emoji} {block.title}
              </h4>
              <p className="text-xs text-gray-400 m-0" data-id="element-233">{block.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}